import { useCallback, useEffect, useRef } from 'react'
import { useNavigationType } from 'react-router-dom'
import { useScrollStore } from '@store/common/useScrollStore.js'
import { restoreScroll } from '@utils/restoreScroll.js'

export const MSTOCK_SCROLL_KEY = {
  HOME: '/main',
  NEWS_LIST: '/mstock/news'
}

export const useScrollMemory = (key, { isReady = true } = {}) => {
  const navigationType = useNavigationType()
  const hasRestoredRef = useRef(false)

  useEffect(() => {
    if (navigationType !== 'POP') return
    if (!isReady) return
    if (hasRestoredRef.current) return

    hasRestoredRef.current = true

    restoreScroll(key)
  }, [navigationType, isReady, key])

  return useCallback(() => {
    useScrollStore.getState().saveScrollY(key)
  }, [key])
}
